import { ResultMessage } from "components/ResultMessage";
import { atom } from "jotai";
import { useSetAtom } from "jotai";
import { getNoReadCount } from "service/notice";
import { errorMessage } from "service/service";

//未读通知数量
export const unReadCountAtom = atom(0);

//更新
export function useUpdateCounts() {
    const setCounts = useSetAtom(unReadCountAtom);

    return async function onDelete() {
        try {
            const newCounts = await getNoReadCount();
            setCounts(newCounts);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };
}
